import { useTranslation } from 'react-i18next'
import { FCC } from '~/core/@types/global'
import LPContainer from './LPContainer'
import Link from 'next/link'
import { Button } from '~/core/ui/Button'
import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'
import Image from 'next/image'

const SolutionsRecruitmentAgencySection: FCC<{ className?: string }> = ({
  className
}) => {
  const { t, i18n } = useTranslation()

  return (
    <div className="relative bg-white py-[64px] tablet:py-[100px]">
      <LPContainer className="flex tablet:flex-row flex-col items-center">
        <div className="flex-1 desktop:mr-8 desktop:mb-0 mb-8">
          <span className="px-2 text-base uppercase rounded bg-green-100 text-green-800">
            {t('solutions:bannerAgency:tag')}
          </span>
          <TypographyText className="leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px] text-center tablet:text-left">
            {t('solutions:bannerAgency:title')}
          </TypographyText>
          <TypographyText className="mt-6 mb-8 text-gray-700 text-base font-normal text-center tablet:text-left">
            {t('solutions:bannerAgency:description')}
          </TypographyText>
          <div className="flex justify-center tablet:justify-start">
            <Link
              href={configuration.path.contactRequest}
              locale={i18n?.language}>
              <Button size="xl" label={`${t('lp:request_demo')}`} />
            </Link>
          </div>
        </div>
        <div className="tablet:w-[640px] h-320px w-full flex items-center">
          <Image
            src="/img/feature/lp/new/solution-recruitment-agency-banner.png"
            alt="solution enterprise banner"
            width={640}
            height={0}
          />
        </div>
      </LPContainer>
    </div>
  )
}

export default SolutionsRecruitmentAgencySection
